import images from 'config/images.json'

export enum ImagesDirectory {
  BANNERS = 'banners',
  PROMOTIONS = 'promotions',
}

export function splitImageUrl(url: string) {
  const lastSlashIndex = url.lastIndexOf('/')
  const baseURL = url.substring(0, lastSlashIndex)
  const name = url.replace('/source.', '.').split('/').pop().split('.')[0]
  const ext = url.split('.').pop()

  return { baseURL, name, ext }
}

export function generateImageUrl(imageName: string, directory: ImagesDirectory): string {
  const { name, ext } = splitImageUrl(imageName)
  const imageUrl = `${images.bucket}/${directory}/${name}/source.${ext}`

  return imageUrl
}
